<template>
   <div class="bodyLogin">
      <div class="d-flex flex-column justify-content-center align-items-center login__container">
          <div class="w-100 login mx-auto " style="padding-bottom: 8px; padding-top: 16px">
              <router-view/>
          </div>
      </div>
    </div>
</template>

<script>
export default {

}
</script>